import AssignedDepartmentField from './AssignedDepartmentField';

export default AssignedDepartmentField;
